import React, { useEffect, useState } from "react";
import AppContainer from "../Structure/AppContainer";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";
import useStateCallback from "../../util/customHooks/useStateCallback";

import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CreateSuppliers from "./CreateSuppliers";
import SupplierDetails from "./SupplierDetails";
import UpdateSupplier from "./UpdateSupplier";
const SuppliersPage = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [meta, setMeta] = useState("");
  const [page, setPage] = useState(1);
  // Fetch suppliers list
  const fetchSuppliersList = async () => {
    var data = { page: page };
    const server_response = await ajaxSuppliers.fetchSuppliersList(data);
    if (server_response.status === "OK") {
      setSuppliers(server_response.details.list);
      setMeta(server_response.details.meta.list_of_pages);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchSuppliersList();
  }, [page]);
  // Handle form submit
  const setNextPageNumber = () => {
    if (meta.length !== page) {
      setPage(page + 1);
    }
  };
  const setPreviousPageNumber = () => {
    if (page !== 1) {
      setPage(page - 1);
    }
  };
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };

  const [Details, setDetails] = useStateCallback(false);
  // Modal handlers
  const handleDetails = (e, SupID) => {
    setDetails(false, () => setDetails(<SupplierDetails SupID={SupID} />));
  };
  const [Update, setUpdate] = useStateCallback(false);
  // Modal handlers
  const handleUpdate = (e, SupID) => {
    setUpdate(false, () => setUpdate(<UpdateSupplier SupID={SupID} />));
  };

  return (
    <AppContainer title="Suppliers">
      {Details}
      {Update}
      <div className="row row-sm">
        <CreateSuppliers func={fetchSuppliersList} />

        {/* Suppliers Table */}
        <div className="col-lg-12 col-md-12">
          <div className="card custom-card card-dashboard-calendar pb-0">
            <label className="main-content-label mb-2 pt-1">
              Organisation Suppliers
            </label>
            <span className="d-block tx-12 mb-2 text-muted">
              List of registered suppliers
            </span>
            <table className="col-lg-12 table table-striped table-hover table-bordered table-responsive">
              <thead>
                <tr>
                  <th></th>
                  <th>NO</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Person</th>
                  <th>Person Contact</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(suppliers) &&
                  suppliers.map((sup, key) => (
                    <tr key={sup.id || key}>
                      <td>
                        <div className="main-img-user avatar-md">
                          <img
                            alt="avatar"
                            className="rounded-circle me-3"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/img/animal_house.png"
                            }
                          />
                        </div>
                      </td>
                      <td>{key + 1}</td>
                      <td>{sup.buss_name}</td>
                      <td>{sup.buss_contact}</td>
                      <td>{sup.buss_email}</td>
                      <td>{sup.contact_person}</td>
                      <td>{sup.person_contact}</td>
                      <td>{sup.status === 1 ? "Active" : "Inactive"}</td>
                      <td>
                        {/* Action Buttons */}
                        <button
                          className="btn btn-sm btn-warning me-1"
                          onClick={(e) => handleDetails(e, sup.id)}
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={(e) => handleUpdate(e, sup.id)}
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button className="btn btn-sm btn-danger">
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <nav className="mt-3" style={{ marginLeft: "30px" }}>
              <ul className="pagination ">
                <li className="page-item">
                  <button className="page-link" onClick={setPreviousPageNumber}>
                    Prev
                  </button>
                </li>
                {Array.isArray(meta) &&
                  meta.map((item) =>
                    page === item ? (
                      <li className="page-item active" key={item}>
                        <a className="page-link" href="javascript:void(0);">
                          {item}
                        </a>
                      </li>
                    ) : (
                      <li className="page-item" key={item}>
                        <a
                          className="page-link"
                          href="#"
                          onClick={(e) => setPageNumber(e, item)}
                        >
                          {item}
                        </a>
                      </li>
                    )
                  )}
                <li className="page-item">
                  <button className="page-link" onClick={setNextPageNumber}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default SuppliersPage;
